import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSyncEvent, selectPollingSync, selectSyncEventStatus } from '../store/slices/despachoNacionalesSlice';

const POLLING_INTERVAL = 3000; // 3 seconds

export const useFacturaLocalPolling = () => {
  const dispatch = useDispatch();
  const pollingSync = useSelector(selectPollingSync);
  const syncEventStatus = useSelector(selectSyncEventStatus);
  const pollingIntervals = useRef({});

  useEffect(() => {
    const intervals = pollingIntervals.current;
    
    // Start polling for each pedido that needs it
    Object.entries(pollingSync).forEach(([pedidoId, shouldPoll]) => {
      if (shouldPoll && syncEventStatus[pedidoId]?.syncEventId) {
        // Clear existing interval if any
        if (intervals[pedidoId]) {
          clearInterval(intervals[pedidoId]);
        }

        // Fetch immediately
        dispatch(fetchSyncEvent({ syncEventId: syncEventStatus[pedidoId].syncEventId }));

        // Set up polling interval
        intervals[pedidoId] = setInterval(() => {
          dispatch(fetchSyncEvent({ syncEventId: syncEventStatus[pedidoId].syncEventId }));
        }, POLLING_INTERVAL);
      } else if (!shouldPoll && intervals[pedidoId]) {
        // Clear interval if polling should stop
        clearInterval(intervals[pedidoId]);
        delete intervals[pedidoId];
      }
    });

    // Cleanup on unmount
    return () => {
      Object.values(intervals).forEach(interval => clearInterval(interval));
    };
  }, [pollingSync, syncEventStatus, dispatch]);

  return {
    syncEventStatus,
    pollingSync
  };
};
